<script>
  import request from 'superagent';
  import { createEventDispatcher } from 'svelte';
  
  const dispatch = createEventDispatcher();
  
  export let video = {};
  
  $: domain = parseDomain();
  
  function playVideo(slug) {
    dispatch("playVideo", slug)
  }
  
  function parseDomain() {
    let r = video.uri.match(/^(\w+:\/\/)?(.[^/]+)/);
    if (r === null || r.length < 3) return "";
    return r[2];
  }
  
  function like() {
    request.post(`/rate/link/${video.id}.jsr`)
      .then(resp => {
        if (resp.statusCode == 200)
          video.rating++;
        else if (resp.statusCode == 204)
          video.rating--;
      })
      .catch(resp => {
        console.log("Error when LIKING")
        console.log(JSON.stringify(resp))
      });
  }
</script>
{#if video}
<div class='row mb-2 p-1'>
<div class='col-12 col-md-4'>
{#if video.video_id && video.image}
<img alt='{video.title}' class='img-fluid' src='{video.image}'>
{/if}
</div>
<div class='col-12 col-md-8'>
<h6 class='mb-0'>
<a href='{video.uri}' on:click|preventDefault='{()=>playVideo(video.slug)}'>
{video.title}
</a>
</h6>
<div class='meta text-muted'>
{#if video.language && video.language != 'cz'}
<span class='badge badge-light badge-lg'>
{video.language}
</span>
{/if}
{#if video.channel_name}
<div class='text-muted'>
{video.channel_name}
</div>
{/if}
<small class='badge text-muted pntr' on:click='{() => like()}'>
<i class='fa fa-star'></i>
</small>
</div>
</div>
</div>
{/if}

